'use strict';

var deployment = process.env.DEPLOYMENT || 'preprod';
var baseUrl = deployment === 'prod' ? 'https://www.liveauctioneers.com' : 'https://' + deployment + '-test.liveauctioneers.com';
var classicBaseUrl = deployment === 'prod' ? 'https://classic.liveauctioneers.com' : 'https://mainhost-' + deployment + '.liveauctioneers.com';
var segmentWriteKey = deployment === 'prod' ? 'HoHgffZL05YMRQr7OAzt1zyzp9ySNQnq' : '2VVBXTAj8OAmELKqpJhQBVy8wxquVSE5';
var buildNumber = process.env.BUILD;
var cachekey = 20170802; // change to break cache.
var pubNubPublishKey = 'pub-c-58c3ded8-2bbd-4100-98a3-b4e4b518195e';
var pubNubSubscribeKey = 'sub-c-f9e57914-c020-11e7-a6e9-2676b4d2b7bb';

var baseCuratorImgUrl = 'https://s3.amazonaws.com/images.liveauctioneers.com/curators';
var curatorImgUrl = deployment === 'prod' || deployment === 'preprod' ? baseCuratorImgUrl : baseCuratorImgUrl + '/stage';

module.exports = {
    auctionHouseSize: 3,
    baseUrl: baseUrl,
    buildNumber: buildNumber,
    cachekey: cachekey,
    classicBaseUrl: classicBaseUrl,
    curatorImgUrl: curatorImgUrl,
    deployment: deployment,
    giveRawResults: true,
    googleApiKey: 'AIzaSyBuqhxwHg5xqsBxp2Wnv0TlptXduChjwOw',
    host: process.env.HOST || 'localhost',
    port: process.env.PORT || 3000,
    pubNubPublishKey: pubNubPublishKey,
    pubNubSubscribeKey: pubNubSubscribeKey,
    querySize: 6,
    sailthruCustomerId: '3ae424afe5d152e7a420ba8614f4ba16',
    segmentWriteKey: segmentWriteKey,
    soastaMPulseApiKey: 'P4TR8-DZB39-665FZ-Q5A4W-7K7EB'
};


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = QmSG
// module chunks = 46